import { ApolloError } from '@shared/apollo';

import type { ExaminationCourseCreationFormInput } from '../../schema';

type ExaminationCourseCreationFormKey = Extract<
  keyof ExaminationCourseCreationFormInput,
  'name' | 'code'
>;

interface ValidationError {
  property: ExaminationCourseCreationFormKey;
  constraints?: Record<string, string>;
}

const ERROR_MESSAGES: Record<ExaminationCourseCreationFormKey, string> = {
  name: 'ชื่อหลักสูตรทดสอบนี้มีอยู่ในระบบแล้ว กรุณากรอกชื่ออื่น',
  code: 'Exam Code นี้มีอยู่ในระบบแล้ว กรุณากรอก Exam Code อื่น',
};

export function transformExamCourseCreationErrors(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return [];
  }

  const extensions = error.cause?.extensions;
  if (!extensions || typeof extensions !== 'object' || Array.isArray(extensions)) {
    return [];
  }

  const details = extensions.details as ValidationError[];
  if (!Array.isArray(details)) {
    return [];
  }

  return details.map(({ property, constraints }) => ({
    property,
    message: constraints?.isUnique ? ERROR_MESSAGES[property] : '',
  }));
}
